module.exports = "<html>\n  <body>\n    <p>Ho</p>\n  </body>\n</html>";